import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export const RedirectToPayables = () => {
  const { id } = useParams();

  return <Navigate to={`/constructions/${id}/payables`} replace />;
};
